import React, { Component } from 'react'
import { Select, Button, Tooltip } from 'hljd'
import SearchBar from '@common/SearchBar'
import store from '../../../store'
import { observer } from 'mobx-react'
import style from './index.module.less'
import { isWeddingDressPhotoProperty } from '@merchant-backend/util'

const Option = Select.Option
const Item = SearchBar.Item

@observer
export default class extends Component {
  render() {
    const { key } = store
    return (
      <div className={style.searchWrap}>
        <SearchBar
          store={store}
          onInited={searchBar => (store.searchBar = searchBar)}
          showReset={false}
          showSearch={false}
        >
          <Item name="source" initialValue={undefined}>
            <Select style={{ width: 100 }} placeholder="来源">
              <Option value={''}>全部</Option>
              <Option value={'1'}>水镜</Option>
              <Option value={'0'}>商家端</Option>
            </Select>
          </Item>

          {isWeddingDressPhotoProperty() && (
            <Item name="meal_type" initialValue={undefined}>
              <Select style={{ width: 100 }} placeholder="类型">
                <Option value={''}>全部</Option>
                <Option value={'1'}>样片</Option>
                <Option value={'2'}>客照</Option>
              </Select>
            </Item>
          )}

          <Item>
            <Select
              style={{ width: 120 }}
              placeholder="案例信息"
              value={store.is_cover_img}
              onChange={value =>
                store.setStoreData('is_cover_img', value, true)
              }
            >
              <Option value={''}>全部</Option>
              <Option value={'3'}>信息缺失</Option>
              <Option value={'2'}>未设置封面</Option>
              <Option value={'1'}>已设置封面</Option>
              <Option value={'4'}>图片未分区</Option>
            </Select>
          </Item>
        </SearchBar>
        {key == 1 && (
          <Tooltip placement="topRight" title="调整案例在店铺中的显示顺序">
            <Button className={style.sortBtn} onClick={store.sortManage}>
              排序管理
            </Button>
          </Tooltip>
        )}
      </div>
    )
  }
}
